import type { JSX } from "react";
import { FluentProvider, webLightTheme, Spinner } from "@fluentui/react-components";
import { AuthProvider } from "@/services/auth/auth-context";
import { useAuth } from "@/services/auth/use-auth";
import { Login } from "@/components/Login";
import { Workflow } from "@/components/Workflow";
import "./App.scss";

function Shell(): JSX.Element {
  const { isAuthenticated, initializing } = useAuth();

  if (initializing) {
    return (
      <div className="app__center">
        <Spinner size="small" label="Loading…" />
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;

  return (
    <div className="app">
      <Workflow />
    </div>
  );
}

export function App(): JSX.Element {
  return (
    <FluentProvider theme={webLightTheme}>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </FluentProvider>
  );
}
